const messageCategory = {
    path: 'category',
    component: resolve => require(['@/pages/admin/system/category.vue'], resolve)
}

export default messageCategory